export const statusColorMap = {
  requested: 'text-primary',
  confirmed: 'text-success',
  rejected: 'text-error',
  canceled: 'text-error',
}
